import './Manage.css'
import {Col, Row, Select, Switch, Typography} from "antd";
import ReactDOM from 'react-dom';

const { Text } = Typography;
const { Option } = Select

interface IManage {
    comp: number;
    showMapToggle: () => void
    showMap: boolean
    page: string
    setPageHandler: (page: string) => void
    autoCenter: boolean
    autoCenterToggle: () => void
    showIphoneToggle: () => void
    showIphone: boolean
}

export default function Manage(props: IManage) {
    const { comp } = props
    function resetMap() {
        const requestOptions = {
            method: 'POST',
            headers: {'Accept': 'application/json'},
            body: JSON.stringify({ comp })
        }

        fetch('https://www.4sport-live.com/epic/resetMap/', {...requestOptions, credentials: "omit"})
            .then(response => response.json())
            .then((response) => {
                    console.log('ok reset')
                },
                (error) => {
                    console.log('error reset')
                }
            )
    }

    function onMouseEnter() {
        document.getElementById('outer-div')!.style.opacity = '1'
    }

    function onMouseLeave() {
        document.getElementById('outer-div')!.style.opacity = '0'
    }

    return ReactDOM.createPortal(
        <div id={'outer-div'} className={'manage-outer-div'} onMouseEnter={onMouseEnter}  onMouseLeave={onMouseLeave}>
            <div className={'manage-div'}>
                <br/>
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col span={24} >
                                <Select defaultValue={props.page} className={'select-page'} onSelect={props.setPageHandler}>
                                    <Option value={'results'}>results</Option>
                                    <Option value={'map'}>map</Option>
                                </Select>
                            </Col>
                        </Row>
                        <Row style={{marginTop: '5px'}}>
                            <Col span={4}>
                                {props.page === 'map' &&
                                <div className={'reset-btn'}>
                                    <button onClick={resetMap}>Reset map</button>
                                </div>
                                }
                            </Col>
                            {props.page === 'map' &&
                            <Col span={8}>
                                <div className={'switch-map-div'}>
                                    <Text className={'switch-text'}>הצג אייפון</Text>
                                    <Switch
                                        className={'switch-map'}
                                        checked={props.showIphone}
                                        onChange={props.showIphoneToggle}
                                    />

                                </div>

                                <div className={'switch-map-div'}>
                                    <Text className={'switch-text'}>הצג מפה</Text>
                                    <Switch
                                        className={'switch-map'}
                                        checked={props.showMap}
                                        onChange={props.showMapToggle}
                                    />
                                </div>

                                <div className={'switch-map-div'}>
                                    <Text className={'switch-text'}>סנטר אוט</Text>
                                    <Switch
                                        className={'switch-map'}
                                        checked={props.autoCenter}
                                        onChange={props.autoCenterToggle}
                                    />
                                </div>
                            </Col>
                            }
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
        , document.getElementById('modals')!
    )
}